module.exports = __webpack_public_path__ + "img/Delete-Btn.43a8cb08.svg";